import React, { useState, useEffect } from 'react';
import {
  PageHeader, Image, Row, Col
} from 'antd';
import styled from 'styled-components';
import { fetchOrders } from 'utils/orders';
import Breadcrumb from 'components/BreadCrumb';
import OrdersTable from 'containers/orders/table/Table';
import AuthenticatorWithEmail from 'utils/authentificator';

const ImageFile = require('./assets/orders.png');

const Orders = (props) => {
  console.log(props, 'props');
  const [orders, setOrders] = useState([]);

  const fetchCustomerOrders = async () => {
    try {
      const list = await fetchOrders();
      console.log(list, 'list');
      // eslint-disable-next-line no-underscore-dangle
      setOrders(list?.data?.listOrders?.items.filter(item => !item._deleted));
    } catch (e) {
      console.error(e.toString());
    }
  };

  useEffect(async () => {
    await fetchCustomerOrders();
  }, []);

  return (
    <AuthenticatorWithEmail>
      <PageHeader
        style={{ border: '1px solid #d9d9d9' }}
        title="Mes recettes"
        breadcrumb={(
          <Breadcrumb
            items={[
              ['Accueil', '/'],
              ['Mes devis'],
            ]}
          />
        )}
      />
      <InnerContent>
        <Row justify="center" type="flex" align="middle">
          <Col span={6}>
            <Image src={ImageFile.default} width="100%" preview={false} />
          </Col>
        </Row>
        <OrdersTable orders={orders} />
      </InnerContent>
    </AuthenticatorWithEmail>
  );
};

const InnerContent = styled.div`
  background: #fff;
  margin: 0px;
  margin-top: 20px;
`;

export default Orders;
